import { useState } from 'react';
import { api, jsonBody } from './api';
import { Modal } from './Modal';

export const PERMISSIONS = [
  ['ddns:write', '更新 DDNS'],
  ['data:read', '读取数据'],
  ['data:write', '写入数据'],
  ['events:read', '读取事件'],
  ['events:write', '写入事件'],
  ['logger:write', '写入 Logger'],
  ['console:read', '读取 Console 命令'],
  ['console:ack', '回复 Console 命令'],
  ['files:read', '读取文件'],
  ['files:write', '写入文件'],
  ['files:manage', '管理文件目录'],
  ['files:publish', '设置文件公开权限'],
  ['files:global:read', '读取全局文件'],
  ['files:global:write', '写入全局文件'],
  ['files:global:manage', '管理全局目录'],
  ['files:global:publish', '设置全局文件公开权限'],
  ['notifications:send', '发送通知'],
  ['messages:read', '拉取下发消息'],
  ['messages:ack', '确认消息结果'],
] as const;

export function KeyPermissionEditor({ keyInfo, endpoint, allowGlobal = false, onClose, onSaved }: {
  keyInfo: { name: string; permissions: string[] };
  endpoint: string;
  allowGlobal?: boolean;
  onClose: () => void;
  onSaved: (permissions: string[]) => void;
}) {
  const [permissions, setPermissions] = useState(keyInfo.permissions);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const options = PERMISSIONS.filter(([id]) => allowGlobal || !id.startsWith('files:global:') || keyInfo.permissions.includes(id));
  return <Modal title="修改密钥权限" subtitle={keyInfo.name} onClose={onClose} dismissOnBackdrop={false}>
    <form className="stack-form" onSubmit={async (event) => {
      event.preventDefault();
      if (saving) return;
      setSaving(true); setError('');
      try {
        const result = await api<{ permissions: string[] }>(endpoint, { method: 'PATCH', body: jsonBody({ permissions }) });
        onSaved(result.permissions);
      } catch (reason) { setError(reason instanceof Error ? reason.message : '保存失败，请重试'); }
      finally { setSaving(false); }
    }}>
      <p className="form-note">保存后立即生效，客户端继续使用现有密钥。</p>
      {!allowGlobal && keyInfo.permissions.some((id) => id.startsWith('files:global:')) && <p className="form-note">全局权限由管理员授予；此处可保留或移除已有授权。</p>}
      <fieldset disabled={saving}><legend>权限范围</legend><div className="permission-grid">{options.map(([id, label]) => <label className="check-card" key={id}>
        <input type="checkbox" checked={permissions.includes(id)} onChange={(event) => setPermissions(event.target.checked ? [...permissions, id] : permissions.filter((item) => item !== id))} />
        <span><strong>{label}</strong><code>{id}</code></span>
      </label>)}</div></fieldset>
      {error && <div className="form-error" role="alert">{error}</div>}
      <div className="modal-actions"><button type="button" className="secondary-button" onClick={onClose} disabled={saving}>取消</button><button className="primary-button" disabled={saving || !permissions.length}>{saving ? '正在保存…' : '保存权限'}</button></div>
    </form>
  </Modal>;
}
